import { NgModule } from '@angular/core';
// application-pipes.module.ts
// other imports
import { SafeHTMLPipe } from './safe-html.pipe';
import { FaDateTimePipe } from './fa-date-time.pipe';
import { FaDatePipe } from './fa-date.pipe';
import { FaNumberPipe } from './fa-number.pipe';
import { FaMoneyPipe } from './fa-money.pipe';

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [
    SafeHTMLPipe,
    FaDateTimePipe,
    FaDatePipe,
    FaNumberPipe,
    FaMoneyPipe,
  ],
  exports: [
    SafeHTMLPipe,
    FaDateTimePipe,
    FaDatePipe,
    FaNumberPipe,
    FaMoneyPipe,
  ],
})
export class ApplicationPipesModule {}
